import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { ImportsModule } from '../imports/imports';
// import { PrimengTableComponent } from './components/primeng-table/primeng-table.component';
// import { PrimengBreadcrumbComponent } from './components/primeng-breadcrumb/primeng-breadcrumb.component';
// import { PrimengSpinnerComponent } from './components/primeng-spinner/primeng-spinner.component';
// import { DynamicDialogModule } from 'primeng/dynamicdialog';
// import { ConfirmationService } from 'primeng/api';
// import { AlphaNumericDirective } from './directives/alpha-numeric-directive';
// import { CropLogoComponent } from './components/crop-logo/crop-logo.component';
// import { ImageCropperComponent } from 'ngx-image-cropper';
// import { CustomPhoneNumberComponent } from './components/custom-phone-number/custom-phone-number.component';
// import { CustomDatePipe } from '../../pipes/custom-date.pipe';
// import { NoDataComponent } from './components/no-data/no-data.component';
// import { ChatDirective } from './directives/chat.directive';
// import { PrimengTreeTableComponent } from './components/primeng-tree-table/primeng-tree-table.component';

@NgModule({
  declarations: [
    // PrimengTableComponent,
    // PrimengTreeTableComponent,
    // PrimengBreadcrumbComponent,
    // PrimengSpinnerComponent,
    // AlphaNumericDirective,
    // CropLogoComponent,
    // CustomPhoneNumberComponent,
    // NoDataComponent,
    // ChatDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // ImportsModule,
    // DynamicDialogModule,
    // ImageCropperComponent,
    // CustomDatePipe,
  ],
  exports: [
    // PrimengTableComponent,
    // PrimengTreeTableComponent,
    // PrimengBreadcrumbComponent,
    // PrimengSpinnerComponent,
    // AlphaNumericDirective,
    // CropLogoComponent,
    // CustomPhoneNumberComponent,
    // NoDataComponent,
    // ChatDirective
  ],
  providers:[],

})
export class SharedModule { }
